import { render } from "./ObjectThreshold.vue?vue&type=template&id=2bd242fb&ts=true"
import script from "./ObjectThreshold.vue?vue&type=script&lang=ts"
export * from "./ObjectThreshold.vue?vue&type=script&lang=ts"

import "./ObjectThreshold.vue?vue&type=style&index=0&id=2bd242fb&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__